module.exports = __webpack_public_path__ + "images/icons_v2/remove-1279daed.svg";